import validation from '../../../scripts/services/validation';

export default [
  '$scope', '$uibModalInstance', 'popupService', 'reportService', 'analyticsService', 'deviceService',
  function ($scope, $uibModalInstance, popupService, reportService, analyticsService, deviceService) {

  this.isMobile = deviceService.isMobile;
  $scope.$watch('form', () => {
    this.validationEmail = validation(this.form, 'email', {
      required: 'Введите email',
      email: 'Введите корректный email',
    });

    this.validationMessage = validation(this.form, 'message', {
      required: 'Введите текст сообщения',
    });
  });

  this.sendReport = () => {
    this.form.$setSubmitted(true);
    if (!this.form.$valid) {
      return;
    }

    analyticsService.trackReportErrorModalSend();

    // TODO показать уведомление в правом углу
    reportService
      .sendError({
        email: this.email,
        text: this.message,
      })
      .then(() => {
        $uibModalInstance.dismiss('sent');

        if (deviceService.isMobile) {
          $uibModalInstance.closed.then(() => {
            popupService.openPopup('reportMessageOk');
          });
        } else {
          popupService.openPopup('reportMessageOk');
        }
      }, () => {
        $uibModalInstance.dismiss('error');

        if (deviceService.isMobile) {
          $uibModalInstance.closed.then(() => {
            popupService.openPopup('reportMessageError');
          });
        } else {
          popupService.openPopup('reportMessageError');
        }
      });
  };
}];
